<template>
  <div class="login-page">
    <div class="login-container">
      <!-- GIAS 제목 (왼쪽) -->
      <div class="login-header">
        <h1>
          <span>
            <img class="logo--base" src="@/assets/common/ezims logo2.png" alt="SuBPay">
          </span>
          <br />

        </h1>
      </div>

      <!-- 로그인 폼 (오른쪽) -->
      <div class="login-box">
        <p class="login-title">LOGIN</p>
        <div class="input-box">
          <label>아이디</label>
          <input type="text" placeholder="아이디를 입력해주세요" v-model="state.id" />
        </div>
        <div class="input-box">
          <label>비밀번호</label>
          <input type="password" placeholder="비밀번호를 입력해주세요" v-model="state.password" @keyup.enter="goLogin" />
        </div>
        <button type="button" class="login-button" @click="goLogin">로그인</button>

        <div class="find-text">
          <span @click="goFindId">아이디 찾기</span> | <span @click="goFindPassword">비밀번호 찾기</span>
        </div>

        <button type="button" class="register-button" @click="goJoin">회원가입</button>
        <!-- <button type="button" class="orgReg-button" @click="goOrgJoin">기관 등록</button> -->
        <div class="guide-text">
          <span @click="guideDown">사용 매뉴얼 다운로드</span>
        </div>
      </div>
    </div>

    <!-- 푸터 -->
    <div class="footer">
      <div class="footer__content">
        <!-- (1) 로고들 (무한 슬라이드 마퀴 적용) -->
        <div class="footer__logos marquee">
          <div class="marquee-inner">
            <div v-for="(logo, i) in doubledLogos" :key="i" class="logo-item">
              <a :href="logo.href" target="_blank" class="footer__logo-link">
                <img :src="logo.src" :alt="logo.alt" class="footer__logo" />
              </a>
            </div>
          </div>
        </div>

        <!-- (2) 아래 영역: info(왼쪽), family(오른쪽) -->
        <div class="footer__bottom">
          <!-- (2-1) 주소/전화/카피라이트 -->
          <div class="footer__info">
            <p class="footer__address">
              08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬)
              <span>대표전화: 070-4489-7241</span>
            </p>
            <p class="footer__copy">
              Copyright by 2025 아트너컨설팅. All Right Reserved
            </p>
          </div>

          <!-- (2-2) Family Site 드롭다운 (옵션) -->
          <div class="footer__family">
            <button class="dropdown-toggle" @click.stop="toggleDropdown">
              Family Site
            </button>
            <ul v-if="isOpen" class="dropdown-menu">
              <li @click="goToSite('https://www.artner.co.kr')">아트너컨설팅</li>
              <li @click="goToSite('https://blackedge.news')">블랙엣지뉴스</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script setup>
import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import * as Utils from '@/common/util/util'
import { userLogin } from '@/api/user'
//import userManual from "@/assets/common"
const store = useStore()
const router = useRouter()

const state = reactive({
  id: '',
  password: '',
});

const goJoin = async () => {
  //router.push({ name: 'join' })
  router.push({ name: 'joinType' })
}

const apiBaseUrl = process.env.VUE_APP_API_URL; // 환경변수에서 API URL 가져오기

const guideDown = async () => {
  try {
    const response = await fetch(`${apiBaseUrl}/up_imgs/guide_file/ezqar%20logo2.png`);
    const blob = await response.blob(); // 파일 데이터를 Blob 형태로 변환

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob); // Blob을 URL로 변환
    link.download = "사용_매뉴얼.png"; // 다운로드될 파일명 설정
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("파일 다운로드 오류:", error);
    alert("파일을 다운로드할 수 없습니다.");
  }
};


const goOrgJoin = async () => {
  router.push({ name: 'orgJoin' })
}
const checkField = () => {

  if (Utils.isEmpty(state.id)) {
    alert("아이디를 입력해주세요")
    return false
  }

  if (Utils.isEmpty(state.password)) {
    alert("비밀번호를 입력해주세요")
    return false
  }
  return true
}
const goFindId = () => {
  router.push({ name: 'findID' }); // 아이디 찾기 화면으로 이동
};

const goFindPassword = () => {
  router.push({ name: 'findPW' }); // 비밀번호 찾기 화면으로 이동
};
const goLogin = async () => {
  if (!checkField()) { return false }

  let param = {
    id: state.id,
    memberPassword: state.password
  }

  const resultVo = await userLogin(param)

  console.log("결과" + resultVo)
  if (resultVo?.result == 'ok') {
    alert(resultVo.resultMsg)
    //console.log("맴버 코드" ,resultVo.data.memberCode)
    store.commit('temp/setUserInfo', {key : 'memberCode', value: resultVo.data.memberCode})
    store.commit('temp/setUserInfo', {key : 'memberName', value: resultVo.data.memberName})
    store.commit('temp/setUserInfo', {key : 'organizationCode', value: resultVo.data.organizationCode})
    store.commit('temp/setUserInfo', {key : 'organizationName', value: resultVo.data.organizationName})
    store.commit('temp/setUserInfo', {key : 'privilege', value: resultVo.data.privilege})
    store.commit('temp/setUserInfo', {key : 'reviewCompletedYn', value: resultVo.data.reviewCompletedYn})
    store.commit('temp/setUserInfo', {key : 'subRole', value: resultVo.data.subRole})
    router.push({ name: 'noticeList' }).then(() => {
      window.location.reload(); // 강제 새로고침
    });
  } else {
    //alert("실패")
    alert(resultVo.resultMsg)
  }

}
onMounted(async () => {
  document.body.classList.add("body");
})

onUnmounted(() => {
  document.body.classList.remove("body");
})

// 드롭다운 열림/닫힘 상태
const isOpen = ref(false)
function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function goToSite(url) {
  window.open(url, '_blank')
  isOpen.value = false
}

// ★ 푸터 로고 무한 슬라이드 이게 되네 ★ 
const logos = [
  {
    href: "https://www.kamco.or.kr/main.do",
    src: "/files/한국자산관리공사.svg",
    alt: "한국자산관리공사"
  },
  {
    href: "https://www.energy.or.kr/",
    src: "/files/한국에너지공단.svg",
    alt: "한국에너지공단"
  },
  {
    href: "https://www.kosmes.or.kr/nsh/map/main.do",
    src: "/files/중소벤처기업진흥공단.svg",
    alt: "중소벤처기업진흥공단"
  },
  {
    href: "https://www.kibo.or.kr/index.do",
    src: "/files/기술보증기금.svg",
    alt: "기술보증기금"
  },
  {
    href: "https://www.nps.or.kr/jsppage/nps_gate.jsp",
    src: "/files/국민연금공단.svg",
    alt: "국민연금공단"
  },
  {
    href: "https://www.hrdkorea.or.kr/",
    src: "/files/한국산업인력공단.svg",
    alt: "한국산업인력공단"
  },
  {
    href: "https://www.kspo.or.kr/kspo/main/main.do",
    src: "/files/국민체육진흥공단.svg",
    alt: "국민체육진흥공단"
  },


  {
    href: "https://www.add.re.kr/kps",
    src: "/files/국방과학연구소.png",
    alt: "국방과학연구소"
  },
  {
    href: "https://www.khug.or.kr/index.jsp",
    src: "/files/주택도시보증공사.svg",
    alt: "주택도시보증공사"
  },
  {
    href: "https://www.keit.re.kr/",
    src: "/files/한국산업기술기획평가원.png",
    alt: "한국산업기술기획평가원"
  },
  {
    href: "https://www.ekr.or.kr/",
    src: "/files/한국농어촌공사.svg",
    alt: "한국농어촌공사"
  },
  {
    href: "https://www.nhis.or.kr/nhis/index.do",
    src: "/files/국민건강보험공단.svg",
    alt: "국민건강보험공단"
  },
  {
    href: "https://www.kepco-enc.com/",
    src: "/files/한국전력기술.svg",
    alt: "한국전력기술"
  },
  {
    href: "https://www.kospo.co.kr/sites/kospo/index.do",
    src: "/files/한국남부발전.svg",
    alt: "한국남부발전"
  },
  {
    href: "https://www.khnp.co.kr/main/index.do",
    src: "/files/한국수력원자력.png",
    alt: "한국수력원자력"
  },
  {
    href: "https://www.koreg.or.kr/koreg/main.do",
    src: "/files/신용보증재단중앙회.png",
    alt: "신용보증재단중앙회"
  },
  {
    href: "https://www.kodit.co.kr/index.do",
    src: "/files/신용보증기금.svg",
    alt: "신용보증기금"
  },
];

// computed로 원본 배열을 복제하여 두 세트를 이어 붙임
const doubledLogos = computed(() => {
  return [...logos, ...logos, ...logos];
});

</script>

<style scoped>
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #f9fafc;
}

.login-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  max-width: 1200px;
  gap: 50px;
}

.login-header {
  flex: 1;
  text-align: left;
  padding: 20px;
}

.login-header h1 {
  font-size: 48px;
  font-weight: bold;
  line-height: 1.2;
}

.login-box {
  flex: 1;
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.input-box {
  margin-bottom: 15px;
}

.input-box label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}

.input-box input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-button,
.register-button,
.orgReg-button {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.login-button {
  background-color: #193073;
  color: white;
}

.register-button {
  background-color: #A6A085;
  color: white;
}

.orgReg-button {
  background-color: #fd7e14;
  color: white;
}

.find-text {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #000;
}

.find-text span {
  cursor: pointer;
}

.find-text span:hover {
  color: #0056b3;
}

.guide-text {
  margin-top: 7px;
  text-align: right;
  font-size: 12px;
  color: #000;
}

.guide-text span {
  cursor: pointer;
}

.guide-text span:hover {
  color: #0056b3;
}

/* 푸터 */
.footer {
  position: relative;
  /* top: 13vh; */
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f9fafc;
  border-top: 1px solid #ccc;
  padding: 10px 0;
  z-index: 999;
  box-sizing: border-box;
  margin-left: 0px;
}

.footer__content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* ★ 무한 슬라이드(마퀴) 스타일 ★ */
.marquee {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* 마우스 호버 시 애니메이션 일시정지 */
.marquee:hover .marquee-inner {
  animation-play-state: paused;
}

.marquee-inner {
  display: flex;
  min-width: 300%;
  animation: marquee-scroll 90s linear infinite;
}

.logo-item {
  flex: 0 0 auto;
  margin-right: 20px;
  min-width: 144px; /* 로고 너비에 맞게 설정 */
}

.footer__logo-link {
  /* border: 0.5px solid #ccc; */
  display: inline-block;
  margin: 0 8px;
}

.footer__logo {
  /* border: 0.5px solid #d1d1d1; */
  width: 144px;
  height: 60px;
  object-fit: contain;
}

/* 아래 영역: info와 family */
.footer__bottom {
  width: 100%;
  display: flex;
  gap: 0 30px;
  justify-content: center;
  align-items: center;
}

.footer__info {
  text-align: left;
}

.footer__address {
  font-size: 14px;
  color: #333;
  margin: 0 0 4px;
}

.footer__address span {
  margin-left: 10px;
}

.footer__copy {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.footer__family {
  position: relative;
}

.dropdown-toggle {
  border: 1px solid #ccc;
  padding: 6px 12px;
  cursor: pointer;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  border-radius: 4px;
}

.dropdown-toggle:hover {
  background-color: #f2f2f2;
}

.dropdown-menu {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 8px;
  width: 180px;
  background: #fff;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 999;
}

.dropdown-menu li {
  padding: 10px 12px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  color: #333;
}

.dropdown-menu li:hover {
  background-color: #f2f2f2;
}

.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

/* 여백 리셋 */
body>* {
  margin: 0;
  padding: 0;
}

body::after {
  content: "";
  display: block;
  height: 0;
  clear: both;
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>